import { MOTIVE_EDIT } from '../../../../../../routes/paths';
import { MouseEventHandler } from 'react';

export const useMotiveListActions = (
    name: string | number,
    active: boolean
) => {
    const handleEdit: MouseEventHandler<HTMLButtonElement> | undefined = (
        e
    ) => {
        e.stopPropagation();
        window.open(
            `${MOTIVE_EDIT}/${encodeURIComponent(name)}/${active}`,
            '_blank'
        );
    };

    return {
        handleEdit,
    };
};
